export interface Screenshot {
  id: string
  filename: string
  contentType: string
  base64Data: string
  previewUrl: string
  source: 'clipboard' | 'capture' | 'upload'
  createdAt: Date
}

export interface ScreenshotServiceConfig {
  maxScreenshots: number
  maxFileSizeBytes: number
  allowedTypes: string[]
  compressionQuality: number
}

export const DEFAULT_SCREENSHOT_CONFIG: ScreenshotServiceConfig = {
  maxScreenshots: 5,
  maxFileSizeBytes: 5 * 1024 * 1024, // 5MB
  allowedTypes: ['image/png', 'image/jpeg', 'image/gif', 'image/webp'],
  compressionQuality: 0.85,
}
